import React from 'react';

import styles from './CurrentDue.module.css';
import NoBill from './NoBill';
import OverdueAndUpcomingBill from './OverdueAndUpcomingBill';
import UpcomingBill from './UpcomingBill';

import Box from 'common/Box';

export const showUpcomingBill = ({ daysLeftInCycle, renewalUnpaid, overduePurchases }) => {
  return (
    daysLeftInCycle !== null &&
    daysLeftInCycle <= 6 &&
    renewalUnpaid &&
    !(overduePurchases && overduePurchases.length)
  );
}

export const CurrentDue = (props) => {
  const { overduePurchases, user  } = props;

  if (!user) {
    return null;
  }

  let innerComponent;

  // shows overdue purchases
  if (overduePurchases && overduePurchases.length) {
    innerComponent = (<OverdueAndUpcomingBill {...props} />);
  }
  // show sprint and att upcoming bill
  else if (showUpcomingBill(props)) {
    innerComponent = (<UpcomingBill {...props} />);
  }
  else {
    innerComponent = (<NoBill {...props} />);
  }

  return (
    <div className={styles.CurrentDue}>
      <Box>
        {innerComponent}
      </Box>
    </div>
  )
}

export default CurrentDue;
